/**
 * NewsletterSignup - Email signup for Weekly Top Tracks newsletter
 */
import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Mail, Loader2, Check, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function NewsletterSignup({ compact = false }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      setSubscribed(true);
      toast.success('Subscribed! Check your inbox for weekly top tracks.');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (detail?.includes('already')) {
        toast.info("You're already subscribed!");
        setSubscribed(true);
      } else {
        toast.error(detail || 'Failed to subscribe');
      }
    } finally {
      setLoading(false);
    }
  };

  if (subscribed) {
    return (
      <div className={`flex items-center gap-2 ${compact ? '' : 'p-4 bg-[#00ff88]/10 border border-[#00ff88]/30'}`} data-testid="newsletter-subscribed">
        <Check size={18} className="text-[#00ff88]" />
        <span className="text-[#00ff88] font-mono text-sm">Subscribed to Weekly Top Tracks!</span>
      </div>
    );
  }

  if (compact) {
    return (
      <form onSubmit={handleSubscribe} className="flex gap-2" data-testid="newsletter-form">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="bg-[#111] border-[#333] text-white font-mono text-sm h-10"
          data-testid="newsletter-email"
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-[#00CCFF] text-black font-mono text-sm h-10 px-4 hover:bg-[#00E5FF]"
          data-testid="newsletter-submit"
        >
          {loading ? <Loader2 size={14} className="animate-spin" /> : <ArrowRight size={14} />}
        </Button>
      </form>
    );
  }

  return (
    <div className="p-6 bg-gradient-to-r from-[#0a0a0a] to-[#111] border border-[#1a1a1a]" data-testid="newsletter-section">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 bg-[#00CCFF]/10 border border-[#00CCFF]/30 flex items-center justify-center">
          <Mail size={20} className="text-[#00CCFF]" />
        </div>
        <div>
          <h3 className="text-white font-['Chakra_Petch'] uppercase text-sm">Weekly Top Tracks</h3>
          <p className="text-[#666] font-mono text-xs">Get the hottest tracks delivered every Monday</p>
        </div>
      </div>
      <form onSubmit={handleSubscribe} className="flex gap-2">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email..."
          className="flex-1 bg-black border-[#333] text-white font-mono text-sm"
          data-testid="newsletter-email"
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-[#00CCFF] text-black font-['Chakra_Petch'] uppercase hover:bg-[#00E5FF] px-6"
          data-testid="newsletter-submit"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : 'Subscribe'}
        </Button>
      </form>
      <p className="text-[#444] font-mono text-[10px] mt-2">No spam. Unsubscribe anytime.</p>
    </div>
  );
}
